import { Form } from '@mairistem/composants';
import { Sens } from '@mairistem/comptabilite';
import { Combobox, Panel } from '@mairistem/finances-utils';
import type { DropdownOption } from '@mairistem/liste';
import { isEmpty } from 'lodash';
import React from 'react';
import NATURE_PIECE from '../../../constants/mouvements/naturePiece';
import {
	TYPE_BORDEREAU_NAT_TYP_PCE_DEPENSE,
	TYPE_BORDEREAU_NAT_TYP_PCE_RECETTE,
} from '../../../constants/mouvements/typeBordereau';
import TYPE_PIECE from '../../../constants/mouvements/typePiece';
import type PanelComponentProps from '../../../interfaces/pieces/mouvements/panelComponentProps';

const TypologiesPesComponent = ({
	data,
	handlePin,
	onChange,
	panel,
	sens,
}: PanelComponentProps) => {
	const handleNaturePieceChange = (_e, { name, value }) => {
		onChange?.(
			{
				[name]: value,
				// Remise à zéro du type de pièce
				typePiece: null,
			},
			panel,
		);
	};

	const handleTypePieceChange = (_e, { name, value }) =>
		onChange?.({ [name]: value }, panel);

	const tripletList = React.useMemo(() => {
		if (!isEmpty(sens)) {
			return sens === Sens.DEPENSE
				? TYPE_BORDEREAU_NAT_TYP_PCE_DEPENSE
				: TYPE_BORDEREAU_NAT_TYP_PCE_RECETTE;
		}
		return [];
	}, [sens]);

	const typeOptionList = React.useMemo(() => {
		if (!isEmpty(sens)) {
			return sens === Sens.DEPENSE
				? TYPE_PIECE.DEPENSE_LIST
				: TYPE_PIECE.RECETTE_LIST;
		}
		return [];
	}, [sens]);

	const natureOptionList = React.useMemo(() => {
		if (!isEmpty(sens)) {
			return sens === Sens.DEPENSE
				? NATURE_PIECE.DEPENSE_LIST
				: NATURE_PIECE.RECETTE_LIST;
		}
		return [];
	}, [sens]);

	const getNaturePieceOptions = () => {
		const options = [];

		if (!isEmpty(data?.bordereau?.typePes)) {
			const naturesPiece = Object.keys(tripletList[data.bordereau.typePes]);
			return natureOptionList.filter((option) =>
				naturesPiece.includes(option.value),
			);
		}
		return options;
	};

	const getTypePieceOptions = () => {
		const options = [];
		if (!isEmpty(data?.bordereau?.typePes) && !isEmpty(data?.naturePiece)) {
			const typesPiece = tripletList[data.bordereau.typePes][data.naturePiece];

			return typeOptionList.filter((option: DropdownOption) =>
				typesPiece.includes(option.value),
			);
		}

		return options;
	};

	return (
		<Panel panel={panel} onPin={handlePin}>
			<Form>
				<Form.Field
					control={Combobox}
					data-testid="naturePieceSelect"
					disabled={!data?.bordereau?.typePes}
					key="naturePiece"
					label="Nature PES"
					name="naturePiece"
					onChange={handleNaturePieceChange}
					options={getNaturePieceOptions()}
					search
					selection
					closeOnBlur={false}
					value={data?.naturePiece ?? ''}
				/>
				<Form.Field
					control={Combobox}
					data-testid="typePieceSelect"
					disabled={!data?.naturePiece}
					key="typePiece"
					label="Type PES"
					name="typePiece"
					onChange={handleTypePieceChange}
					options={getTypePieceOptions()}
					search
					selection
					value={data?.typePiece ?? ''}
				/>
			</Form>
		</Panel>
	);
};

export default TypologiesPesComponent;
